import type { Types } from '@common/models';
import { tuneSubscribe } from '@common/talkn-config';
import Sequence from '@common/Sequence';

type Action = {
  type: string;
  tuneCh: Types['Ch'];
  postsTimeline: (Types['Post'] & { deleted?: boolean })[];
  posts: (Types['Post'] & { deleted?: boolean })[];
};

const getPostKey = (post: Types['Post']): string =>
  `${post.uid}_${post.connection}_${post.createTime || post.content}`;

const deduplicatePosts = (posts: Types['Post'][]): Types['Post'][] => {
  const seen = new Set<string>();
  return posts.filter(post => {
    const key = getPostKey(post);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export default (state: Types['Post'][] = [], action: Action) => {
  switch (action.type) {
    case 'SERVER_TO_API[EMIT]:fetchPosts':
    case `${Sequence.SERVER_TO_API_BROADCAST}${tuneSubscribe.statePosts}`:
      if (action.posts && action.posts.length > 0) {
        const deletions = action.posts.filter(p => p.deleted);
        if (deletions.length > 0) {
          return state.filter(p => !deletions.some(d => d.uid === p.uid && d.replyToId === p.replyToId && d.content === p.content));
        }
      }
      if (action.postsTimeline && action.postsTimeline.length > 0) {
        if (action.tuneCh?.connection === action.postsTimeline[0].connection) {
          return deduplicatePosts([...state, ...action.postsTimeline]);
        }
      }
      if (action.posts && action.posts.length > 0) {
        return deduplicatePosts([...state, ...action.posts]);
      }
      break;
  }
  return state;
};
